"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = exports.token = exports.security = exports.proxy = exports.interfaces = exports.access = void 0;

var _access = _interopRequireWildcard(require("./access"));

exports.access = _access;

var _interfaces = _interopRequireWildcard(require("./interfaces"));

exports.interfaces = _interfaces;

var _proxy = _interopRequireWildcard(require("./proxy"));

exports.proxy = _proxy;

var _security = _interopRequireWildcard(require("./security"));

exports.security = _security;

var _token = _interopRequireWildcard(require("./token"));

exports.token = _token;

var _utils = _interopRequireWildcard(require("./utils"));

exports.utils = _utils;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }